import { MainContent } from '@/app/panel/_components/main-content'
import { Navbar } from '@/app/panel/_components/navbar'
import { NavbarContextProvider } from '@/app/panel/_contexts/navbar-context'
import { useNavbarStorage } from '@/app/panel/_hooks/use-navbar-storage'

type PanelLayoutProps = React.PropsWithChildren

export const PanelLayout = ({ children }: PanelLayoutProps) => {
  const { expandedStorage } = useNavbarStorage()

  return (
    <NavbarContextProvider initialValue={expandedStorage}>
      <div className="flex min-h-screen bg-gray-50">
        <Navbar />

        <MainContent>{children}</MainContent>
      </div>
    </NavbarContextProvider>
  )
}
